import { render, staticRenderFns } from "./CollectionImageUploader.vue?vue&type=template&id=3fdd2049&scoped=true"
import script from "./CollectionImageUploader.vue?vue&type=script&lang=js"
export * from "./CollectionImageUploader.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./CollectionImageUploader.vue?vue&type=style&index=0&id=3fdd2049&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3fdd2049",
  null
  ,true
)

export default component.exports